import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propFunc, } from '../../../../../helpers/custom-prop-types';
// 1:未対応, 2:対応中, 3:対応済み ・・・未対応のもののみ通知で良い？
const countUpContacts = (orders) => {
    const statusesToBeNoticed = [1];
    return orders.filter((order) => statusesToBeNoticed.includes(order.professionalStatus)).length;
};
const DetailContact = ({ onClick, orders }) => (_jsx("div", Object.assign({ className: 'overview-detail' }, { children: _jsxs("div", Object.assign({ className: 'detail-contact' }, { children: [_jsx("span", Object.assign({ className: 'contact-count font-number' }, { children: countUpContacts(orders) })), _jsx("button", Object.assign({ className: 'btn btn-primary small js-accordion-trigger', disabled: orders.length === 0, onClick: onClick, type: 'button' }, { children: "\u5BFE\u5FDC\u72B6\u6CC1" }))] })) })));
DetailContact.propTypes = {
    onClick: propFunc().isRequired,
    orders: propArrayShape().isRequired,
};
export default DetailContact;
